export type SettingsID = number;

export interface Settings {
  created_on: string;
  updated_on: string;
  id: SettingsID;
  name: string;
  locale: string;
  url: string;
}
